import 'ui-core/plugins/drawer/js/drawer';

(function (UX) {
    var menu = UX.menu,
        $body = $('body');

    menu.vPort = ['screen-md'];

    menu.on.show = function (e) {
        if (typeof UX.controller !== 'undefined') {
            UX.controller.check();
        }

        if (e) {
            $(e.target).closest('.main-nav').addClass('js--open');
        }
        $body.addClass('lock-screen').attr('data-active', 'menu');

        menu.$toggle.addClass('js--open');
        menu.$target.attr('style', 'display: block !important');
        menu.$target.attr('aria-expanded', 'true');
    };

    menu.on.hide = function (e) {
        menu.$toggle.removeClass('js--open');
        $body.removeAttr('data-active').removeClass('lock-screen');
        menu.$target.attr('style', '');
        if (e) {
            $(e.target).closest('.main-nav').removeClass('js--open');
        }
        menu.$target.attr('aria-expanded', 'false');
    };
    menu.on.showNestedExtra = function () {
        menu.$target.addClass('sub-menu__opened');
    };

    menu.on.hideNestedExtra = function () {
        if (!$('.menu-parent__opened').length) {
            menu.$target.removeClass('sub-menu__opened');
        }
    };

    menu.checkscrolling = function () {
        if ($('.menubar').width() > $('.generic-menu').width()) {
            $('.generic-menu').addClass('scroll-edge');
        } else {
            $('.generic-menu').removeClass('scroll-edge');
        }
    };

    menu.responsive = function (index) {
        $(document).on(menu.vPort[index] + '-on', function () {
            // Waiting for custom event that will be triggered by controller.js to activate responsive effects
            menu.isMobile = true;
            $('.main-nav').each(function () {
                if ($(this).find('.drawer__nav').data('ctrl-res') === menu.vPort[index]) {
                    $(this).addClass('menu--res'); // class will be used in our scss (to replace media queries)
                    menu.on.rebuild.responsive(); // rebuild menu to be responsive - drawer
                }
            });
            menu.checkscrolling();
        });

        $(document).on(menu.vPort[index] + '-off', function () {
            // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
            menu.isMobile = false;
            $body.removeAttr('data-effect');
            $('.main-nav').each(function () {
                if ($(this).find('.drawer__nav').data('ctrl-res') === menu.vPort[index]) {
                    $(this).removeClass('menu--res'); // class will be used in our scss (to replace media queries)
                    menu.on.rebuild.original(); // return menu as default
                }
            });
            menu.checkscrolling();
        });
    };
    menu.on.listPosition.start = () => {};
    menu.on.listPosition.handleHeightSet = () => {};
    menu.on.listPosition.reset = () => {};

    menu.additionalControl = function () {
        var $openedMenu = null,
            $parentmenu = null;
        $body.on('click', '.generic-menu .dropdown__toggle', function (e) {
            var isOpendByClick = $(this).closest('.open-on-click').length > 0;
            if (menu.isMobile || isOpendByClick) {
                e.preventDefault();
                e.stopPropagation();
                $body.removeAttr('data-effect');

                $openedMenu = $('.generic-menu .js--open');
                $parentmenu = $(this).closest('.menu-parent');

                if ($parentmenu.hasClass('js--open')) {
                    $openedMenu.removeClass('js--open');
                } else {
                    if (isOpendByClick) {
                        $('.dropdown.menu-parent').removeClass('open-on-click');
                    }

                    if (menu.isMobile) {
                        $parentmenu.find('.dropdown__menu__title').text($(this).text());
                        $openedMenu.removeClass('js--open');
                        $parentmenu.addClass('js--open');
                        $body.attr('data-effect', 'body-overlay');
                    }
                }
            }
        });
        $body.on('click', '.dropdown__menu', function (e) {
            e.stopPropagation();
        });

        $body.on('click touchend', '.dropdown__menu__header .icon-close ', function (e) {
            e.preventDefault();
            $('.generic-menu .js--open').removeClass('js--open');
            $('.dropdown.menu-parent').removeClass('open-on-click');
            $body.removeAttr('data-effect');
        });
    };
})(UX);
